<template>
  <div>
    <span>
      <font-awesome-icon :icon="['far', 'search']" />
    </span>
    <!-- <span class="input-group-prepend border-0">
      <div class="input-group-text bg-white border-0">
        <font-awesome-icon icon="search" class="form-control-feedback" />
      </div>
    </span>-->
    <input type="search" :disabled="disabled" class="form-control" placeholder="Search by patient, doctor or practice name..." v-model="searchTerm" :style="{
        'padding-left': currentPracticeFilter
          ? 2.75 + Math.ceil(currentPracticeFilter.name.length / 2) + 'rem'
          : '2.375rem',
      }" />
    <div class="badge badge-info text-capitalize" style="position: absolute; top: 0.275rem; left: 2.375rem" v-if="currentPracticeFilter">
      {{ currentPracticeFilter.name.toLowerCase() }}
      <a href="javascript:void(0)" @click="$store.dispatch(model + '/setPracticeContext', null)">
        <font-awesome-icon :icon="['far', 'times']" class="ml-2" />
      </a>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
export default {
  props: {
    model: {
      type: String,
      default: 'referrals',
    },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters('practices', ['byId']),
    currentPracticeFilter() {
      return (
        this.modelState.contextPracticeId &&
        this.byId(this.modelState.contextPracticeId)
      )
    },
    modelState() {
      return this.$store.state[this.model]
    },
    searchTerm: {
      get() {
        return this.$store.state[this.model].searchTerm
      },
      set(value) {
        if (this.disabled) return
        this.$store.dispatch(this.model + '/search', value)
      },
    },
  },
  async created() {},
}
</script>

<style scoped lang="scss">
input[type='search'] {
  /* padding: 1.25rem; */
  padding-left: 2.375rem;
  height: 2.375rem;
  border-radius: 8px;
  border: none;
  border-color: #ffffff;
  border-style: solid;
  border-width: 0px;
  /* box-shadow: 1px 2px 5px 0px rgba(199, 199, 199, 0.22); */
  /* box-shadow: 2px 3px 7px rgba(0, 0, 0, 0.05); */

  &:disabled {
    cursor: progress;
  }
}

input[type='search']::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
}

span {
  position: absolute;
  z-index: 5;
  display: block;
  width: 2.375rem;
  height: 2.375rem;
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
}

.badge.badge-info {
  background-color: rgb(232, 246, 255);
  color: var(--secondary);
  padding: 0.75em 1em;
  font-size: 0.85em;
}
.badge.badge-info a {
  color: var(--link-color);
}
</style>
